/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const useHasForgeAccess = (): boolean => {
	return true;
};
